export const footerMoreLinks = {
  'in-ar': [
    {
      title: 'أكثر',
      items: [
        {
          href: 'https://www.wingie.co.in/ar/contact/',
          title: 'التواصل',
        },
        {
          href: 'https://www.wingie.co.in/ar/faq/',
          title: 'الأسئلة المتكررة',
        },
        {
          href: 'https://www.wingie.co.in/ar/about-us/',
          title: 'تعرّف علينا',
        },
        {
          href: 'https://www.wingie.co.in/ar/privacy/',
          title: 'الخصوصية - وينجي',
        },
        {
          href: 'https://www.wingie.co.in/ar/terms-and-conditions/',
          title: 'شروط الاستخدام',
        },
        {
          href: 'https://www.wingie.co.in/ar/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'in-en': [
    {
      title: 'More',
      items: [
        {
          href: 'https://www.wingie.co.in/contact/',
          title: 'Contact',
        },
        {
          href: 'https://www.wingie.co.in/faq/',
          title: 'Frequently Asked Questions',
        },
        {
          href: 'https://www.wingie.co.in/about-us/',
          title: 'About us',
        },
        {
          href: 'https://www.wingie.co.in/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://www.wingie.co.in/terms-and-conditions/',
          title: 'Terms and Conditions',
        },
        {
          href: 'https://www.wingie.co.in/awards/',
          title: 'Our Awards',
        },
      ],
    },
  ],
  'in-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://www.wingie.co.in/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://www.wingie.co.in/es/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },
        {
          href: 'https://www.wingie.co.in/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://www.wingie.co.in/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://www.wingie.co.in/es/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          href: 'https://www.wingie.co.in/es/awards/',
          title: 'Nuestros premios',
        },
      ],
    },
  ],
  'in-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://www.wingie.co.in/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://www.wingie.co.in/de/faq/',
          title: 'Häufig gestellte Fragen - Wingie',
        },
        {
          href: 'https://www.wingie.co.in/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://www.wingie.co.in/de/datenschutz/',
          title: 'Datenschutz & Cookies',
        },
        {
          href: 'https://www.wingie.co.in/de/allgemeine-geschaeftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://www.wingie.co.in/de/awards/',
          title: 'Unsere Auszeichnungen',
        },
      ],
    },
  ],
  'in-ru': [
    {
      title: 'более',
      items: [
        {
          href: 'https://www.wingie.co.in/ru/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://www.wingie.co.in/ru/faq/',
          title: 'Часто задаваемые вопросы',
        },
        {
          href: 'https://www.wingie.co.in/ru/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://www.wingie.co.in/ru/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://www.wingie.co.in/ru/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://www.wingie.co.in/ru/awards/',
          title: 'Наши награды',
        },
      ],
    },
  ],
  'in-it': [
    {
      title: 'Di più',
      items: [
        { href: 'https://www.wingie.co.in/it/contact/', title: 'Contatto' },
        // { href: 'https://www.wingie.co.in/it/faq/', title: 'Domande frequenti' },
        { href: 'https://www.wingie.co.in/it/about-us/', title: 'Chi siamo' },
        { href: 'https://www.wingie.co.in/it/privacy/', title: 'Privacy' },
        { href: 'https://www.wingie.co.in/it/terms-and-conditions/', title: 'Termini e condizioni' },
        { href: 'https://www.wingie.co.in/it/awards/', title: 'I nostri premi' },
      ],
    },
  ],
  'in-fr': [
    {
      title: 'Plus',
      items: [
        { href: 'https://www.wingie.co.in/fr/contact/', title: 'Contact' },
        // { href: 'https://www.wingie.co.in/fr/faq/', title: 'Questions fréquemment posées' },
        { href: 'https://www.wingie.co.in/fr/about-us/', title: 'À propos de nous' },
        { href: 'https://www.wingie.co.in/fr/privacy/', title: 'Confidentialité' },
        { href: 'https://www.wingie.co.in/fr/terms-and-conditions/', title: 'Termes et conditions' },
        { href: 'https://www.wingie.co.in/fr/awards/', title: 'Nos récompenses' },
      ],
    },
  ],
  'in-pt': [
    {
      title: 'Mais',
      items: [
        { href: 'https://www.wingie.co.in/pt/contact/', title: 'Contato' },
        // { href: 'https://www.wingie.co.in/pt/faq/', title: 'Perguntas frequentes' },
        { href: 'https://www.wingie.co.in/pt/about-us/', title: 'Sobre nós' },
        { href: 'https://www.wingie.co.in/pt/privacy/', title: 'Privacidade' },
        { href: 'https://www.wingie.co.in/pt/terms-and-conditions/', title: 'Termos e condições' },
        { href: 'https://www.wingie.co.in/pt/awards/', title: 'Nossos prêmios' },
      ],
    },
  ],
  'in-ro': [
    {
      title: 'Mai multe',
      items: [
        { href: 'https://www.wingie.co.in/ro/contact/', title: 'Contact' },
        // { href: 'https://www.wingie.co.in/ro/faq/', title: 'Întrebări frecvente' },
        { href: 'https://www.wingie.co.in/ro/about-us/', title: 'Despre noi' },
        { href: 'https://www.wingie.co.in/ro/privacy/', title: 'Confidențialitate' },
        { href: 'https://www.wingie.co.in/ro/terms-and-conditions/', title: 'Termeni și condiții' },
        { href: 'https://www.wingie.co.in/ro/awards/', title: 'Premiile noastre' },
      ],
    },
  ],
  'in-pl': [
    {
      title: 'Więcej',
      items: [
        { href: 'https://www.wingie.co.in/pl/contact/', title: 'Kontakt' },
        // { href: 'https://www.wingie.co.in/pl/faq/', title: 'Często zadawane pytania' },
        { href: 'https://www.wingie.co.in/pl/about-us/', title: 'O nas' },
        { href: 'https://www.wingie.co.in/pl/privacy/', title: 'Prywatność' },
        { href: 'https://www.wingie.co.in/pl/terms-and-conditions/', title: 'Regulamin' },
        { href: 'https://www.wingie.co.in/pl/awards/', title: 'Nasze nagrody' },
      ],
    },
  ],
  'in-lt': [
    {
      title: 'Daugiau',
      items: [
        { href: 'https://www.wingie.co.in/lt/contact/', title: 'Kontaktai' },
        // { href: 'https://www.wingie.co.in/lt/faq/', title: 'Dažnai užduodami klausimai' },
        { href: 'https://www.wingie.co.in/lt/about-us/', title: 'Apie mus' },
        { href: 'https://www.wingie.co.in/lt/privacy/', title: 'Privatumas' },
        { href: 'https://www.wingie.co.in/lt/terms-and-conditions/', title: 'Sąlygos' },
        { href: 'https://www.wingie.co.in/lt/awards/', title: 'Mūsų apdovanojimai' },
      ],
    },
  ],
  'in-uz': [
    {
      title: 'Boshqa',
      items: [
        { href: 'https://www.wingie.co.in/uz/contact/', title: 'Kontakt' },
        // { href: 'https://www.wingie.co.in/uz/faq/', title: "Ko'p beriladigan savollar" },
        { href: 'https://www.wingie.co.in/uz/about-us/', title: 'Biz haqimizda' },
        { href: 'https://www.wingie.co.in/uz/privacy/', title: 'Maxfiylik' },
        { href: 'https://www.wingie.co.in/uz/terms-and-conditions/', title: 'Shartlar va qoidalar' },
        { href: 'https://www.wingie.co.in/uz/awards/', title: 'Bizning mukofotlar' },
      ],
    },
  ],
  'in-sr': [
    {
      title: 'Више',
      items: [
        { href: 'https://www.wingie.co.in/sr/contact/', title: 'Контакт' },
        // { href: 'https://www.wingie.co.in/sr/faq/', title: 'Често постављана питања' },
        { href: 'https://www.wingie.co.in/sr/about-us/', title: 'О нама' },
        { href: 'https://www.wingie.co.in/sr/privacy/', title: 'Приватност' },
        { href: 'https://www.wingie.co.in/sr/terms-and-conditions/', title: 'Услови коришћења' },
        { href: 'https://www.wingie.co.in/sr/awards/', title: 'Наше награде' },
      ],
    },
  ],
  'in-ky': [
    {
      title: 'Көбүрөөк',
      items: [
        { href: 'https://www.wingie.co.in/ky/contact/', title: 'Байланыш' },
        // { href: 'https://www.wingie.co.in/ky/faq/', title: 'Көп берилүүчү суроолор' },
        { href: 'https://www.wingie.co.in/ky/about-us/', title: 'Биз жөнүндө' },
        { href: 'https://www.wingie.co.in/ky/privacy/', title: 'Купуялык' },
        { href: 'https://www.wingie.co.in/ky/terms-and-conditions/', title: 'Шарттар жана эрежелер' },
        { href: 'https://www.wingie.co.in/ky/awards/', title: 'Биздин сыйлыктар' },
      ],
    },
  ],
  'in-tg': [
    {
      title: 'Бештар',
      items: [
        { href: 'https://www.wingie.co.in/tg/contact/', title: 'Тамос' },
        // { href: 'https://www.wingie.co.in/tg/faq/', title: 'Саволҳои зиёд додашаванда' },
        { href: 'https://www.wingie.co.in/tg/about-us/', title: 'Дар бораи мо' },
        { href: 'https://www.wingie.co.in/tg/privacy/', title: 'Махфият' },
        { href: 'https://www.wingie.co.in/tg/terms-and-conditions/', title: 'Шартҳо ва қоидаҳо' },
        { href: 'https://www.wingie.co.in/tg/awards/', title: 'Мукофотҳои мо' },
      ],
    },
  ],
  'in-kk': [
    {
      title: 'Көбірек',
      items: [
        { href: 'https://www.wingie.co.in/kk/contact/', title: 'Байланыс' },
        // { href: 'https://www.wingie.co.in/kk/faq/', title: 'Жиі қойылатын сұрақтар' },
        { href: 'https://www.wingie.co.in/kk/about-us/', title: 'Біз туралы' },
        { href: 'https://www.wingie.co.in/kk/privacy/', title: 'Құпиялылық' },
        { href: 'https://www.wingie.co.in/kk/terms-and-conditions/', title: 'Шарттар мен ережелер' },
        { href: 'https://www.wingie.co.in/kk/awards/', title: 'Біздің марапаттар' },
      ],
    },
  ],
  'in-nl': [
    {
      title: 'Meer',
      items: [
        { href: 'https://www.wingie.co.in/nl/contact/', title: 'Contact' },
        // { href: 'https://www.wingie.co.in/nl/faq/', title: 'Veelgestelde vragen' },
        { href: 'https://www.wingie.co.in/nl/about-us/', title: 'Over ons' },
        { href: 'https://www.wingie.co.in/nl/privacy/', title: 'Privacy' },
        { href: 'https://www.wingie.co.in/nl/terms-and-conditions/', title: 'Voorwaarden' },
        { href: 'https://www.wingie.co.in/nl/awards/', title: 'Onze prijzen' },
      ],
    },
  ],
  'in-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://www.wingie.co.in/ja/contact/' },
        { title: 'よくある質問', href: 'https://www.wingie.co.in/en/faq/' },
        { title: '会社概要', href: 'https://www.wingie.co.in/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://www.wingie.co.in/ja/privacy/' },
        { title: '利用規約', href: 'https://www.wingie.co.in/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://www.wingie.co.in/ja/awards/' },
      ],
    },
  ],
  'in-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://www.wingie.co.in/zh/contact/' },
        { title: '常见问题', href: 'https://www.wingie.co.in/en/faq/' },
        { title: '关于我们', href: 'https://www.wingie.co.in/zh/about-us/' },
        { title: '隐私政策', href: 'https://www.wingie.co.in/zh/privacy/' },
        { title: '条款和条件', href: 'https://www.wingie.co.in/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://www.wingie.co.in/zh/awards/' },
      ],
    },
  ],
  'in-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://www.wingie.co.in/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://www.wingie.co.in/en/faq/' },
        { title: '회사 소개', href: 'https://www.wingie.co.in/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://www.wingie.co.in/ko/privacy/' },
        { title: '이용약관', href: 'https://www.wingie.co.in/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://www.wingie.co.in/ko/awards/' },
      ],
    },
  ],
  'in-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://www.wingie.co.in/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://www.wingie.co.in/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://www.wingie.co.in/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://www.wingie.co.in/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://www.wingie.co.in/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://www.wingie.co.in/hi/awards/' },
      ],
    },
  ],
  'in-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://www.wingie.co.in/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://www.wingie.co.in/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://www.wingie.co.in/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://www.wingie.co.in/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://www.wingie.co.in/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://www.wingie.co.in/ta/awards/' },
      ],
    },
  ],
  'in-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://www.wingie.co.in/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://www.wingie.co.in/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://www.wingie.co.in/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://www.wingie.co.in/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://www.wingie.co.in/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://www.wingie.co.in/th/awards/' },
      ],
    },
  ],
  'in-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://www.wingie.co.in/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://www.wingie.co.in/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://www.wingie.co.in/ur/about-us/' },
        { title: 'رازداری', href: 'https://www.wingie.co.in/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://www.wingie.co.in/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://www.wingie.co.in/ur/awards/' },
      ],
    },
  ],
  'in-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://www.wingie.co.in/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://www.wingie.co.in/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://www.wingie.co.in/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://www.wingie.co.in/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://www.wingie.co.in/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://www.wingie.co.in/ka/awards/' },
      ],
    },
  ],
}
